<template>
  <div class="city-contain">

    <div class="progress-box line_bottom" v-for="(item,index) in listData" :key="index" @click="navTo(item)">
      <div class="name">
        <div>{{item.projectName.replace(/\（.*?\）/g, "")}}</div>
        <!-- <div>{{item.projectName}}</div> -->
        <div v-if="Number(item.deduction)==0" class="txt"></div>
        <div v-else class="txt">-{{item.deduction}}</div>
      </div>
      <div class="line">
        <div class="left">
          <div v-if="Number(item.totalScore)==20" :style="'width:'+(processWidth*(Number(item.totalScore)/20))+'px'" class="total-bg">
            <div v-if="Number(item.score)>=2" :style="'width:'+ (processWidth*(Number(item.score)/20)) +'px'" class="cur-bg">{{item.score}}</div>
            <div v-if="Number(item.score)==0" class="zero">{{item.score}}</div>
            <template v-if="Number(item.score)>0 && Number(item.score)<2">
              <div :style="'width:'+ (processWidth*(Number(item.score)/20)) +'px'" class="cur-bg"></div>
              <span class="green" :style="'margin-left:'+ (processWidth*(Number(item.score)/20))+'px'">{{item.score}}</span>
            </template>
          </div>
          <div v-if="Number(item.totalScore)<20 && Number(item.totalScore)>3" :style="'width:'+(processWidth*(Number(item.totalScore)/13))+'px'" class="total-bg">
            <div v-if="Number(item.score)>=2" :style="'width:'+ (processWidth*(Number(item.score)/13)) +'px'" class="cur-bg">{{item.score}}</div>
            <div v-if="Number(item.score)==0" class="zero">{{item.score}}</div>
            <template v-if="Number(item.score)>0 && Number(item.score)<2">
              <div :style="'width:'+ (processWidth*(Number(item.score)/13)) +'px'" class="cur-bg"></div>
              <span class="green" :style="'margin-left:'+ (processWidth*(Number(item.score)/13))+'px'">{{item.score}}</span>
            </template>
          </div>
          <div v-if="Number(item.totalScore)==3" :style="'width:'+(processWidth*(5/13))+'px'" class="total-bg">
            <div v-if="Number(item.score)>=1.5" :style="'width:'+ (processWidth*(Number(item.score)/13))*(5/3) +'px'" class="cur-bg">{{item.score}}</div>
            <div v-if="Number(item.score)==0" class="zero">{{item.score}}</div>
            <template v-if="Number(item.score)>0 && Number(item.score)<1.5">
              <div :style="'width:'+ (processWidth*(Number(item.score)/13))*(5/3) +'px'" class="cur-bg"></div>
              <span class="green" :style="'margin-left:'+ (processWidth*(Number(item.score)/13))*(5/3)+'px'">{{item.score}}</span>
            </template>
          </div>
          <!--总分 totalScore 得分score 扣分 deduction -->
          <div class="total-num">{{item.totalScore}}<span class="fz10">分</span></div>
        </div>
        <!-- 与上季度对比分数 -->
        <template v-if="isOpen">
          <div class="right down" v-if="Number(item.scoreChange)<0">
            <span>{{item.scoreChange}}</span>
            <!-- <span>&#160;↓</span> -->
            <img class="r-img" src="../../../assets/appraise/down.png"/>
          </div>
          <div class="right up" v-if="Number(item.scoreChange)>0">
            <span>+{{item.scoreChange}}</span>
            <!-- <span>&#160;↑</span> -->
            <img class="r-img" src="../../../assets/appraise/up.png"/>
          </div>
          <div class="right blue" v-if="Number(item.scoreChange)==0">
            <span>持平</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'rankCharts',
        watch: {
          isOpen: {
            immediate: true,
            handler: function (val) {
              console.log('isOpen:', val);
            }
          }
        },
        data () {
            return {
                processWidth: 210
            }
        },
        props: {
            year:'',
            listData: {
                type: Array
            },
            // switch开关的值
            isOpen: {
                type: Boolean
            }
        },
        methods: {
            navTo (row) {
              if(Number(this.year)<2023){
                return
              }
              if (row.clickBtn) {
                sessionStorage.setItem('projectName', row.projectName)
                // console.log(area, 'area')id, directDetail, assessType, projectName
                console.log('----evolve测试路由拦截：', row);
                this.$emit('navToScoreList', row)
              }else{
                this.$toast('您没有该考核项查询权限')
              }
            }
        },
        mounted () {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .progress-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 78px;
    // border-bottom: solid 1px #EEEEEE;
    padding: 0 16px;
    .name{
      display: flex;
      justify-content: space-between;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:14px;
      .txt{
        color: #FF4D4D;
      }
    }
    .line{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      .left{
        display: flex;
        align-items: center;
        margin-right:16px;
        .total-bg{
          position: relative;
          // width: 227px;
          height:20px;
          background:rgba(54,179,116,.1);
          border-radius:10px;
          .cur-bg{
            position: absolute;
            left: 0;
            top:0;
            width: 100px;
            height:20px;
            line-height: 20px;
            background:rgba(54,179,116,1);
            border-radius:10px;
            padding: 0 8px;
            box-sizing: border-box;
            font-size:14px;
            font-family:DIN-Medium,DIN;
            font-weight:500;
            color:rgba(255,255,255,1);
            text-align: right;
          }
          .zero{
            position: absolute;
            left: 0;
            top:0;
            width: 100px;
            height:20px;
            line-height: 20px;
            border-radius:10px;
            padding: 0 8px;
            box-sizing: border-box;
            font-size:14px;
            font-family:DIN-Medium,DIN;
            font-weight:500;
            color:rgba(54,179,116,1);
          }
          .green{
            font-size:14px;
            font-family:DIN-Medium,DIN;
            font-weight:500;
            color:rgba(54,179,116,1);
            display: inline-block;
            padding: 0 8px;
            line-height: 20px;
            width: 100%;
            box-sizing: border-box;
          }
        }
        .total-num{
          font-size:14px;
          font-family:DIN-Medium,DIN;
          font-weight:500;
          color:rgba(102,102,102,1);
          line-height:14px;
          margin-left: 16px;
          .fz10{
            font-size: 10px;
          }
        }
      }
      .right{
        display: flex;
        align-items: flex-end;
        .r-img{
          width: 8px;
          height: 12px;
          margin-left: 1px;
        }
      }
      .down{
        color: #FF4D4D;
      }
      .up{
        color:#36B374;
      }
      .blue{
        color: #2283E6;
      }
    }
    :last-child{
      border-bottom: 0;
    }
  }
  .line_bottom:last-child::after{
    background: none;
  }
  .mr01{
    margin-right: -1px;
  }
}
</style>
